// extracted by mini-css-extract-plugin
export default {"item":"item--btWVc","link":"link--1sGjM","icon":"icon--3Zoct"};